namespace GeniuzPOS.Purchase {
    export interface PoPurInvoiceDtRow {
        Id?: number;
        SysDocNo?: string;
        SupplierId?: string;
        ShopId?: string;
        WhsId?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        LastPurUnitPrice?: number;
        Qty?: number;
        BeforeDiscAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        ItemAmt?: number;
        SalesVatTypes?: string;
        VatType?: string;
        VatCode?: string;
        VatRate?: number;
        ItemVatAmt?: number;
        ItemExVatAmt?: number;
        AlocalteDiscAmt?: number;
        ItemNetAmt?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        PrRefDocNo?: string;
        PrLineId?: number;
        QtyUse?: number;
        UseFg?: number;
        ItemExciseTaxAmt?: number;
        ItemNetCostValue?: number;
    }

    export namespace PoPurInvoiceDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPurInvoiceDt';
        export const lookupKey = 'Purchase.PoPurInvoiceDt';

        export function getLookup(): Q.Lookup<PoPurInvoiceDtRow> {
            return Q.getLookup<PoPurInvoiceDtRow>('Purchase.PoPurInvoiceDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            SupplierId = "SupplierId",
            ShopId = "ShopId",
            WhsId = "WhsId",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            LastPurUnitPrice = "LastPurUnitPrice",
            Qty = "Qty",
            BeforeDiscAmt = "BeforeDiscAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            ItemAmt = "ItemAmt",
            SalesVatTypes = "SalesVatTypes",
            VatType = "VatType",
            VatCode = "VatCode",
            VatRate = "VatRate",
            ItemVatAmt = "ItemVatAmt",
            ItemExVatAmt = "ItemExVatAmt",
            AlocalteDiscAmt = "AlocalteDiscAmt",
            ItemNetAmt = "ItemNetAmt",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            PrRefDocNo = "PrRefDocNo",
            PrLineId = "PrLineId",
            QtyUse = "QtyUse",
            UseFg = "UseFg",
            ItemExciseTaxAmt = "ItemExciseTaxAmt",
            ItemNetCostValue = "ItemNetCostValue"
        }
    }
}
